module.exports = "/_next/static/images/TwilioDeveloperPlan@2x-9a1f22b0ff2fa9b754511868f12b8598.png";